export default "__VITE_ASSET__ee0f6a50__"